import { getToolDescription, getToolTitle } from 'src/data/generationTool';

export const generateToolListTooltip = (toolList) =>
  toolList.reduce(
    (accumulator, currentValue) =>
      accumulator +
      formatTooltipLine(getToolTitle(currentValue), getToolDescription(currentValue)) +
      '\n',
    ''
  );

export const formatTooltipLine = (title, description) =>
  `${title}${description ? ` - ${description}` : ''}`;
